import styled from "styled-components";

export const HoverModal = styled.div`
  position: fixed;
  left: ${({ left }) => `${left}px`};
  top: ${({ top }) => `${top}px`};
  transform: translate(-50%, -50%);
  z-index: 10000;
  background-color: #141414;
  border-radius: 12px;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.85);
  overflow: hidden;
  color: #ffffff;
  width: 310px;
  max-width: 90vw;
  cursor: pointer;

  .hover-modal-content {
    display: flex;
    flex-direction: column;
  }

  .hover-modal-image-wrapper {
    width: 100%;
    height: 220px;
    overflow: hidden;
  }

  .hover-modal-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .hover-modal-body {
    padding: 16px 18px 18px;
  }

  .hover-modal-title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 6px;
  }

  .hover-modal-description {
    font-size: 13px;
    line-height: 1.5;
    color: #e5e5e5;
    max-height: 80px;
    overflow: hidden;
  }

  .hover-modal-play-button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    border-radius: 20px;
    border: none;
    background-color: #ffffff;
    color: #000000;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.2s ease, background-color 0.2s ease;
    margin-bottom: 8px;
  }

  .hover-modal-play-button:hover {
    transform: scale(1.05);
    background-color: #e50914;
    color: #ffffff;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;


